/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RoleType = {
    CustomRole: 'CustomRole',
    PredefinedRole: 'PredefinedRole',
    SystemRole: 'SystemRole'
} as const;
export type RoleType = typeof RoleType[keyof typeof RoleType];


export function RoleTypeFromJSON(json: any): RoleType {
    return RoleTypeFromJSONTyped(json, false);
}

export function RoleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleType {
    return json as RoleType;
}

export function RoleTypeToJSON(value?: RoleType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the RoleType interface.
 */
 export function instanceOfRoleType(value: any): value is RoleType {
    return Object.values(RoleType).includes(value)
}

